import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.986 2.912a.5.5 0 0 1 .458.253.5.5 0 0 1 .062.24V9.33c0 .086.067.158.133.163l.031.001h5.925a.497.497 0 0 1 .493.52 6.757 6.757 0 1 1-7.102-7.102m-.47 1.038-.122.019a5.768 5.768 0 1 0 6.655 6.527l.001-.013H8.652l-.067-.003a1.2 1.2 0 0 1-.366-.089 1.2 1.2 0 0 1-.276-.166 1.1 1.1 0 0 1-.22-.237 1.14 1.14 0 0 1-.205-.604l-.001-.054zM9.99 1.255a6.757 6.757 0 0 1 6.754 6.802.4.4 0 0 1-.023.111.6.6 0 0 1-.074.14.6.6 0 0 1-.078.083.5.5 0 0 1-.137.08.5.5 0 0 1-.133.032l-.047.003H9.989a.495.495 0 0 1-.492-.447l-.003-.048V1.75a.49.49 0 0 1 .306-.457.5.5 0 0 1 .189-.037m.494 1.01v5.252h5.252l-.003-.043A5.77 5.77 0 0 0 10.64 2.28l-.114-.012z"
    }, null, -1)
  ])))
}
export default { render: render }